import { Flex } from "@chakra-ui/react";
import { AppleStoreLink, PlayStoreLink } from "components/AppStoreLink";
import { Heading, SectionContainer } from "./shared";

export const Download = () => (
  <SectionContainer py="240px" textAlign="center">
    <Heading fontStyle="normal">Put Web3 in your back pocket.</Heading>
    <Heading fontStyle="normal" mb={9}>
      Download the ultimate NFT portfolio tracker now.
    </Heading>
    <Flex flexDirection={{ base: "column", md: "row" }} alignItems="center" justifyContent="center">
      <AppleStoreLink mr={{ base: 0, md: 2 }} mb={{ base: 2, md: 0 }} />
      <PlayStoreLink />
    </Flex>
  </SectionContainer>
);
